import { InputSwitch } from 'primereact/inputswitch'
import { useTranslation } from 'react-i18next'
import { useToggleNotificationRead } from '../hooks/useNotifications'
import type { Notification } from '../types'
// Anahtar zil panelinde de kullanılır; stil, Bildirimler sayfası hiç açılmadan da yüklenmelidir.
import '../notifications.css'

/**
 * Okundu/okunmadı anahtarı (spec FR-017a) — zil paneli ve Bildirimler sayfası **aynı** bileşeni
 * kullanır; iki ekranda etiket, erişilebilir ad ve tazeleme davranışı ayrı düşmez.
 *
 * <p>Mutasyonu kendi içinde tutar: çağıran yalnız satırı verir. Anahtar, istek uçarken pasiftir —
 * ardışık tıklamalarla ileri-geri istek kuyruğu oluşmaz.
 *
 * <p><b>Erişilebilir ad eylemi söyler</b> ("Okundu olarak işaretle"), durumu değil: durumu zaten
 * `role="switch"`in `checked` değeri duyurur; adın da durum söylemesi ekran okuyucuda çift okuma
 * yaratırdı. Sırf renge dayanan bir ayrım da yoktur — satırın kendisi ayrıca kalın/vurgulu gösterilir
 * (spec FR-013), listede ise anahtarın yanında metin etiketi bulunur.
 *
 * <p><b>Ad, bildirimin başlığını da taşır</b> ({@code "eylem: başlık"}): bir listede yan yana beş
 * anahtar vardır ve hepsinin adı "Okundu olarak işaretle" olsaydı ekran okuyucu kullanıcısı hangi
 * bildirimi çevirdiğini anlayamazdı (görsel kullanıcı bunu satırdan okuyor). Repo kalıbıyla aynı —
 * lookup ekranlarındaki satır-içi anahtarlar da kayıt adını erişilebilir ada koyar. Görsel ipucu
 * (tooltip) kısa kalır: orada bağlam zaten satırın kendisidir.
 */
export default function ReadSwitch({ item }: Readonly<{ item: Notification }>) {
  const { t } = useTranslation()
  const toggle = useToggleNotificationRead()

  const action = item.read ? t('notifications.markUnreadAction') : t('notifications.markReadAction')
  const subject = item.subject ?? t('notifications.untitled')

  return (
    <InputSwitch
      className="notif-switch"
      checked={item.read}
      disabled={toggle.isPending}
      onChange={(e) => toggle.mutate({ id: item.id, read: Boolean(e.value) })}
      aria-label={`${action}: ${subject}`}
      tooltip={action}
      tooltipOptions={{ position: 'bottom' }}
    />
  )
}
